import moment from "moment";

export const dateFromThePast = (date) => moment(date).valueOf() < moment(Date.now()).subtract(1, "days");